import * as Yup from "yup";

import {CheckBoxField} from "@/components/form/fields/CheckBoxField.tsx";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {TextAreaField} from "@/components/form/fields/TextAreaField.tsx";
import {RequiredFieldsNote} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.tsx";
import {PropsWithClassName} from "@/lib/types/props.ts";

export interface SSOFormValues {
  idp_entity_id: string;
  idp_sso_target_url: string;
  idp_certificate: string;
  use_sha1_for_signature: boolean;
  unsigned_authn_requests: boolean;
}

export const SSOFormSchema = Yup.object({
  idp_entity_id: Yup.string().defined().default(""),
  idp_sso_target_url: Yup.string().defined().default(""),
  idp_certificate: Yup.string().defined().default(""),
  use_sha1_for_signature: Yup.boolean().default(false),
  unsigned_authn_requests: Yup.boolean().default(false),
});

export const SSOSetupStep2 = ({className}: PropsWithClassName) => (
  <div className={className}>
    <div className="pulseTextH3Bold mb-3">
      Step 2: Paste In The SSO Login Details & Certificate Of Your Identity Provider
    </div>
    <RequiredFieldsNote />
    <InputField
      className="mb-4"
      label="Identity Provider's EntityID / Issuer"
      name="idp_entity_id"
      helpText="The unique identifier of your identity provider."
      required={true}
    />
    <InputField
      className="mb-4"
      label="SSO Target URL"
      name="idp_sso_target_url"
      helpText="The URL used to trigger a login with your identity provider (HTTP-Redirect method)"
      required={true}
    />
    <TextAreaField
      className="mb-4"
      label="Identity Provider's Certificate"
      name="idp_certificate"
      helpText="A valid X.509 certificate in PEM format used for signing by the identity provider."
      rows={10}
      cols={40}
      required={true}
    />
    <CheckBoxField
      className="mb-4"
      label="Use legacy SHA-1 for signing instead of the recommended SHA-256"
      name="use_sha1_for_signature"
      helpText="Please check this only if your identity provider does not support login requests signed with SHA-256."
    />
    <CheckBoxField
      label="Don't digitally sign SAML AuthN login requests (required for Azure)"
      name="unsigned_authn_requests"
      helpText="If you are unable to perform a SAML login via the Uptime.com login form, try enabling this setting."
    />
  </div>
);
